export type CsvTemplate = "schools" | "teachers" | "facilitators";

const templates: Record<CsvTemplate, string[][]> = {
  schools: [
    ["code", "name", "center_code", "is_center"],
    ["CTR-LHR-01", "Government Training Centre Lahore", "", "true"],
    ["SCH-LHR-101", "Government Girls High School Lahore", "CTR-LHR-01", "false"],
    ["SCH-LHR-102", "Government Boys High School Lahore", "CTR-LHR-01", "false"],
  ],
  teachers: [
    [
      "assigned_id",
      "name",
      "password",
      "role",
      "institute_code",
      "center_code",
      "grade",
      "subject",
      "phone",
      "group_code",
    ],
    [
      "T-0001",
      "Ayesha Khan",
      "change-me-123",
      "teacher",
      "SCH-LHR-101",
      "CTR-LHR-01",
      "5",
      "Mathematics",
      "03001234567",
      "SG-2026-A",
    ],
    [
      "T-0002",
      "Hassan Ali",
      "change-me-123",
      "teacher",
      "SCH-LHR-102",
      "CTR-LHR-01",
      "6",
      "Science",
      "03007654321",
      "SG-2026-A",
    ],
  ],
  facilitators: [
    ["assigned_id", "name", "password", "role"],
    ["F-0001", "Ali Raza", "change-me-123", "facilitator"],
    ["F-0002", "Sana Ahmed", "change-me-123", "facilitator"],
  ],
};

function csvCell(value: string) {
  return /[",\r\n]/.test(value) ? `"${value.replaceAll('"', '""')}"` : value;
}

export function downloadCsvTemplate(template: CsvTemplate) {
  const csv = `${templates[template].map((row) => row.map(csvCell).join(",")).join("\r\n")}\r\n`;
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `${template}-import-template.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
